import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    imageContainer:
      'relative h-[330px] w-full max-xl:h-[290px] max-lg:h-[240px]',
    image: 'overflow-hidden rounded-[20px] object-cover',
    meta: 'absolute top-4 right-4 flex gap-1',
    metaItem:
      'heading-xs flex h-6 items-center gap-1 rounded-full bg-white/60 px-2 backdrop-blur-[20px]',
    metaItemIcon: 'text-blue size-4',
    tags: 'absolute bottom-0 left-6 flex translate-y-1/2 gap-2',
    title: 'heading-xl',
    description: 'heading-m mt-2 line-clamp-3',
    content: 'mt-8 px-6',
    buttonChildren: 'flex items-center gap-5',
    button: 'mt-6 mr-auto w-fit !pl-0'
  }
});
